export const CREATOR_FIB_TO_TRAINING = '-121';
export const CREATOR_FIB_TO_JOB = '-205';
export const CREATOR_TRAINING_TO_FIB = '-122';
export const CREATOR_TRAINING_TO_JOB = '-209';
export const CREATOR_JOB_TO_FIB = '-208';
export const CREATOR_JOB_TO_TRAINING = '-210';

// 同步类型
export const FIB_TO_TRAINING = 1;
export const TRAINING_TO_FIB = 3;
export const FIB_TO_JOB = 4;
export const JOB_TO_FIB = 5;
export const TRAINING_TO_JOB = 6;
export const JOB_TO_TRAINING = 7;
export const FIB_TO_FIB = -1; // 留学内部

export default {
  FIB_TO_TRAINING,
  TRAINING_TO_FIB,
  FIB_TO_JOB,
  JOB_TO_FIB,
  TRAINING_TO_JOB,
  JOB_TO_TRAINING,
  FIB_TO_FIB,
};
